import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      border: '1px solid #D2D2D2',
      borderRadius: 6,
      padding: theme.spacing(2, 1.5, 1),

      '& > header': {
        marginBottom: theme.spacing(1),

        display: 'flex',
        alignItems: 'flex-end',
        gap: theme.spacing(1),

        '& > h3': {
          fontSize: '1.6rem',
        },
      },
      '& > section': {
        display: 'grid',
        gridTemplate: 'repeat(3, auto) / repeat(2, 1fr)',
        gap: theme.spacing(1),

        '& > span:first-child, & > span:last-child': {
          gridColumn: '1 / 3',
        },

        '& > span': {
          border: '1px solid #F0F0F0',
          borderRadius: 5,
          padding: theme.spacing(0.4, 2),

          display: 'flex',
          gap: 3,

          '& p': {
            fontSize: '1.2rem',
          },

          '& > p:first-child': {
            fontWeight: 600,
          },

          '&:last-child div': {
            flex: 1,

            display: 'flex',
            justifyContent: 'end',
            gap: '2.4rem',

            '& p': {
              fontWeight: 600,
            },
          },
        },
      },
    },
  }),
)
